import{useState as r}from"react";var n=function(n){var o=r(n),t=o[0],e=o[1];return[t,function(r){e((function(n){return"boolean"==typeof r?r:!n}))}]};export{n as u};
